// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: "proxima-nova", "Sans Serrif";
}

.bottom-button {
  border-top: 1px solid #707070;
  margin-bottom: 70px;
  padding-top: 70px;
  text-align: center;
}
.bottom-button .home-btn-group .k-button {
  background: #0f5597;
  color: #ffffff;
  text-transform: unset;
  font-size: 20px;
  margin: 10px;
  font-weight: bold;
  padding: 30px 16px;
  border-radius: 0;
  width: 100%;
  height: auto;
}
.bottom-button button {
  border-radius: 0px;
  background-color: #0f5597;
  color: white;
  padding: 5px 16px;
  margin: 0px 10px;
}

.denver-content-area-master.override-main {
  display: flex;
  flex-direction: row;
  min-width: 100%;
  min-height: 100%;
  padding: 0;
  margin: 0;
}
.denver-content-area-master.override-main .main-content {
  min-width: 100%;
  display: flex;
  flex-flow: row wrap;
}
@media screen and (max-width: 960px) {
  .denver-content-area-master.override-main .main-content {
    display: block;
  }
  .denver-content-area-master.override-main .section-container {
    border: 0px;
  }
}
@media screen and (min-width: 961px) {
  .denver-content-area-master.override-main .side-panel {
    flex: 1 1 20%;
    max-width: 20%;
  }
  .denver-content-area-master.override-main .main-panel {
    flex: 1 1 80%;
    max-width: 80%;
  }
  .denver-content-area-master.override-main .main-panel.compact {
    flex: 1 1 60%;
    max-width: 60%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/home-layout/home-layout.component.scss"],"names":[],"mappings":"AAAA;EACI,0CAAA;AACJ;;AAIA;EACI,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AAIQ;EACI,mBAVC;EAWD,cAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAFZ;AAMI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAJR;;AAQA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AALJ;AAOI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AALR;AAQI;EACI;IACI,cAAA;EANV;EASM;IACI,WAAA;EAPV;AACF;AAUI;EACI;IACI,aAAA;IACA,cAAA;EARV;EAUM;IACI,aAAA;IACA,cAAA;EARV;EAUU;IACI,aAAA;IACA,cAAA;EARd;AACF","sourcesContent":[":host {\n    font-family: \"proxima-nova\", \"Sans Serrif\";\n}\n\n$base-color: #0f5597;\n\n.bottom-button {\n    border-top: 1px solid #707070;\n    margin-bottom: 70px;\n    padding-top: 70px;\n    text-align: center;\n\n    .home-btn-group {\n        .k-button {\n            background: $base-color;\n            color: #ffffff;\n            text-transform: unset;\n            font-size: 20px;\n            margin: 10px;\n            font-weight: bold;\n            padding: 30px 16px;\n            border-radius: 0;\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    button {\n        border-radius: 0px;\n        background-color: #0f5597;\n        color: white;\n        padding: 5px 16px;\n        margin: 0px 10px;\n    }\n}\n\n.denver-content-area-master.override-main {\n    display: flex;\n    flex-direction: row;\n    min-width: 100%;\n    min-height: 100%;\n    padding: 0;\n    margin: 0;\n\n    .main-content {\n        min-width: 100%;\n        display: flex;\n        flex-flow: row wrap;\n    }\n\n    @media screen and (max-width: 960px) {\n        .main-content {\n            display: block;\n        }\n\n        .section-container { \n            border: 0px;\n        }\n    }\n\n    @media screen and (min-width: 961px) {\n        .side-panel { \n            flex: 1 1 20%; \n            max-width: 20%;\n        }\n        .main-panel { \n            flex: 1 1 80%;\n            max-width: 80%;\n\n            &.compact {\n                flex: 1 1 60%;\n                max-width: 60%;    \n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
